import React from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import store, { rootReducer } from "../../../../store";
import { setRendererFormState } from "../../../../slices/common/reducer";

const DatePicker = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState = {},
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  let key = databaseKey ? databaseKey : displayLabelKey;
  const today = new Date().toISOString().split("T")[0];

  const allowFutureDates = fieldEle?.["allowFutureDates"] === 1;
  const [ageError, setAgeError] = React.useState("");
  const displayYes = fieldEle?.["display-yes"];
  const displayDependent = fieldEle?.["display-dependent"];

  // Visibility Logic
  let shouldDisplay = true;

  if (displayDependent) {
    const parentValue = formState[displayDependent];
    const displayIndex = fieldEle?.["display-index"];
    if (
      parentValue === undefined ||
      parentValue === null ||
      parentValue === ""
    ) {
      shouldDisplay = false;
    } else if (displayIndex !== undefined) {
      shouldDisplay = Number(parentValue) >= Number(displayIndex);
    } else {
      shouldDisplay = !!parentValue;
    }
  } else if (displayYes) {
    const parentValue = formState[displayYes];
    const legacyValues = ["yes", "other", "renewal", "active"];
    shouldDisplay = legacyValues.includes(
      parentValue?.toString().toLowerCase()
    );
  }

  React.useEffect(() => {
    if ((displayYes || displayDependent) && shouldDisplay === false) {
      rootReducer.dispatch(
        setRendererFormState({ key, value: "" })
      );
    }
  }, [displayYes, displayDependent, shouldDisplay, key]);

  if (!shouldDisplay) {
    return null;
  }

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <div className="date">
          <input
            type="date"
            id={newElfromJSON}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            placeholder={fieldEle?.["display-placeholder"]}
            disabled={fieldEle?.["display-disabled"] === 1}
            className="form-control custom-datepicker mandatory"
            autoComplete="off"
            required={showRequired ? fieldEle?.["display-required"] === 1 : false}
            name={key}
            max={!allowFutureDates ? today : null}
            min={allowFutureDates ? today : null}
            value={formState[key]}
            // onChange={(e) =>
            //   rootReducer.dispatch(
            //     setRendererFormState({ key, value: e.target.value })
            //   )
            // }
            onChange={(e) => {
              const inputValue = e.target.value;
              const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
              if (!dateRegex.test(inputValue)) {
                return;
              }
              const minAge = Number(fieldEle?.["validation-min-age"]);
              const maxAge = Number(fieldEle?.["validation-max-age"]);

              if (minAge && maxAge) {
                const dob = new Date(inputValue);
                const todayDate = new Date();

                const maxDob = new Date(
                  todayDate.getFullYear() - minAge,
                  todayDate.getMonth(),
                  todayDate.getDate()
                );

                const minDob = new Date(
                  todayDate.getFullYear() - maxAge,
                  todayDate.getMonth(),
                  todayDate.getDate()
                );

                if (dob > maxDob || dob < minDob) {
                  setAgeError(fieldEle?.["validation-message"] || "");

                } else {
                  setAgeError("");
                }
              }
              rootReducer.dispatch(setRendererFormState({ key, value: inputValue }));
            }}
          />
          <span className="input-group-addon d-none">
            <i className="fa fa-calendar"></i>
          </span>
          <div className="invalid-feedback">This field is required</div>
          {ageError && (<div className="text-danger">{ageError}</div>)}
          {fieldEle?.["display-description"] && (
            <div className="form-text text-muted formElementDesc">
              {fieldEle?.["display-description"]}
            </div>
          )}
        </div>
      </div>
    </FormGroupWrapper>
  );
};

export default DatePicker;
